"use client";

import { MediaWorkspace } from "../_components/MediaWorkspace";
import { convertAudioOperation } from "../_operations/convertAudio";

export function ConvertAudioContent() {
  return <MediaWorkspace operation={convertAudioOperation} />;
}
